import React from 'react';
import SectionContainer from 'components/Containers/SectionContainer';
import { ReactComponent as Close } from 'style/icons/close.svg';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import './creditCardComparison.scss';

const CreditCardComparisonView = props => {
  const { seenPixel, onClose } = props;
  return (
    <>
      {seenPixel}
      <SectionContainer className="creditCardComparison pos-rel">
        <FlexContainer className="margLR40 desktopOnlyHide justify-center m-margT15 m-margB16">
          <img
            alt="Credit Card Comparison Logo"
            src="//csesamesecure.s3.amazonaws.com/s3adminportalmanager/product_manager/art-card-comparison@3x.png"
            width={240}
          />
        </FlexContainer>
        <FlexContainer className="padLR48 m-padLR16">
          <div>
            <div className="pos-abs close">
              <Close className="pointer" onClick={onClose} />
            </div>
            <Label type="H4 margB8">
              Select two cards to compare side by side
            </Label>
            <div className="SubTitle">
              We’ve added a card comparison feature! Use the check box above the
              card to start comparing
            </div>
          </div>
          <div className="margLR60 mobileOnlyHide">
            <img
              alt="Credit Card Comparison Logo"
              src="//csesamesecure.s3.amazonaws.com/s3adminportalmanager/product_manager/art-card-comparison@3x.png"
              width={272}
            />
          </div>
        </FlexContainer>
      </SectionContainer>
    </>
  );
};

export default CreditCardComparisonView;
